<script lang="ts">
	import { makeComponentClassList } from "../utils";

	export let direction: "column" | "row" = "row";
	export let defaultClassName = "";
	export let gap: number = 10;

	$: classVariables = makeComponentClassList($$props);

</script>

<div
	style={`gap : ${gap}px`}
	class:column={direction == 'column'}
	class={defaultClassName + classVariables}>
	<slot />
</div>

<style lang="scss">
	div {
		width: 100%;
		display: flex;

		&.column {
			flex-direction: column;
		}
	}

</style>
